// extracted by mini-css-extract-plugin
export default {"fixed":"Header_fixed__0SiZX","headerCon":"Header_headerCon__sqWMz","nav":"Header_nav__5AN2Q","link":"Header_link__lPmjk","ul":"Header_ul__bQ1Kk"};